import axios from "axios";
import Swal from 'sweetalert2'
import { logOutRedirectCall } from "../pages/Common/RedirectPathMange";

const showMessage = (msg) => {
  Swal.fire({
    title: 'Food For Good',
    text: msg,
    confirmButtonText: 'Okay'
  })
}
const getBaseUrl = () => {
  const hostname = window.location.hostname;
 if (hostname === "booking.foodforgood.ca") {
    return "https://booking.foodforgood.ca:1805/api/v1"; // Live Server
  } else if (hostname === "dev-foodforgood.ddns.net" || hostname === "15.156.145.0") {
    return "https://dev-foodforgood.ddns.net:1805/api/v1"; // Development Server
  } else {
    return "http://localhost:1805/api/v1"; // Local
  }
};

const axiosClient = axios.create({
  baseURL: getBaseUrl(),
  headers: {
    'api-key': 'c2eCYLUtPYIwOPWP/kp1TEYk8B8uzFrjlNqVIuHyYL8=',
    'accept-language': 'en',
    // 'admin-type': 'admin',
    'Content-Type': 'text/plain',
    'app': 'donor'
  }
});

axiosClient.interceptors.request.use(function (config) {
  config.headers['token'] = localStorage.getItem("DAtoken")
  config.data = JSON.stringify(config.data);
  return config;
});

axiosClient.interceptors.response.use(
  function (response) {
    if (response.data.code == 0) {
      showMessage(response.data.message)
    }
    return response;
  }, function (error) {
    let res = error.response;
    if (res.status == 401) {
        logOutRedirectCall();
    }
    console.error("Looks like there was a problem. Status Code: " + res.status);
    return Promise.reject(error);
  }
);

export {
  axiosClient
};